import classNames from 'classnames';
import { css } from 'lit';

import {
  UNLEASH_FEATURE_NAME,
  type AdStatus,
  type AdType
} from '@schibsted-nmp/advertising-shared';
import { isFeatureEnabled } from '@client/core/atoms/unleashFeatures.js';

export function getClassNameByStatus(status: AdStatus) {
  const isEnabledViewabilityDropInvestigation = isFeatureEnabled(
    UNLEASH_FEATURE_NAME.viewabilityDropInvestigation
  );

  return classNames({
    'advt-loaded': status === 'available' || status === 'loaded',
    'advt-empty':
      status === 'error' ||
      status === 'collapsedOnCollision' ||
      (status === 'refresh' && isEnabledViewabilityDropInvestigation)
  });
}

export function getClassNameByType(type: AdType) {
  return classNames({
    'native-ad': type === 'native',
    'video-ad': type === 'video',
    'banner-ad': type === 'banner' || type === 'adnami',
    'sponsored-content': type === 'sponsored-content',
    'takeover-ad': type === 'takeover',
    'intermingles-ad': type === 'intermingles',
    'audience-pixel-ad': type === 'audience-pixel',
    'top1-wallpaper-ad': type === 'top1-wallpaper'
  });
}

export default css`
  :host {
  }
`;
